module.exports = __webpack_public_path__ + "static/img/ban-7-1-1.28fb0d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ban-7-1-1.png
// module id = 1RPe
// module chunks = 0